"use client";
import { useSyncExternalStore } from "react";

/**
 * Sayfa görünürlüğü — TEK document listener'ı ile paylaşılan store.
 *
 * Her bileşenin kendi `visibilitychange` dinleyicisini kurması ana sayfada
 * 168 ayrı dinleyici demekti (84 kart × 2 RotatingText); sekme değiştiğinde
 * 168 setState aynı anda kuyruğa giriyordu. Burada dinleyici modül seviyesinde
 * bir kez kurulur, abone sayısı sıfıra düşünce kaldırılır.
 */
let isVisible = true;
let attached = false;
const listeners = new Set<() => void>();

const handleChange = () => {
  const next = document.visibilityState === "visible";
  // Değer değişmediyse abone uyandırmanın anlamı yok.
  if (next === isVisible) return;
  isVisible = next;
  listeners.forEach((listener) => listener());
};

const subscribe = (onStoreChange: () => void) => {
  if (!attached) {
    isVisible = document.visibilityState === "visible";
    document.addEventListener("visibilitychange", handleChange);
    attached = true;
  }
  listeners.add(onStoreChange);

  return () => {
    listeners.delete(onStoreChange);
    if (listeners.size === 0 && attached) {
      document.removeEventListener("visibilitychange", handleChange);
      attached = false;
    }
  };
};

// Primitif döner — useSyncExternalStore'un referans karşılaştırması güvenli
// (bkz. nesne döndürüldüğünde oluşan sonsuz render döngüsü).
const getSnapshot = () => isVisible;
const getServerSnapshot = () => true;

export const usePageVisible = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default usePageVisible;
